<template>
  <div class="py-10 md:py-20 px-4 md:px-0 bg-semantic-surface-container-low">
    <div class="max-w-wrapper-lg mx-auto">
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="title"
        ref="title"
        class="text-2xl/[120%] text-center md:text-4xl/[150%] mb-2 md:mb-4 text-semantic-surface-on-surface font-semibold"
        v-html="title"
      />
      <p
        v-if="description"
        ref="description"
        :class="{ 'mb-2 md:mb-4': !$slots.default }"
        class="text-base/[150%] text-center md:text-lg/[150%] text-semantic-surface-on-surface"
        v-html="description"
      />
      <slot />
      <swiper-container
        v-if="getItems.length"
        ref="swiper"
        slides-per-view="auto"
        init="false"
        class="overflow-hidden"
        :style="{
          '--swiper-pagination-bottom': '0',
        }"
      >
        <swiper-slide
          v-for="(item, itemKey) in getItems"
          :key="itemKey"
          class="w-auto relative drop-shadow-sm-2 flex flex-col items-stretch"
        >
          <V2MoleculesCardArticleCard
            :title="item.title"
            :description="item.content"
            cta-btn-label="Read more"
            wrapper-class="!max-w-[21.675rem] md:h-[30rem] h-[25rem] !min-w-[20rem] mb-1 mr-1 !border-semantic-util-transparent"
            inner-wrapper-class="md:h-[30rem] h-[20.5rem]"
            image-class="!h-[12rem]"
            :cta-btn-to="item.url"
            :image-path="item.image"
          />
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script setup>
import { register } from 'swiper/element/bundle'
register()

defineOptions({
  name: 'V2OrganismHomeMediaBlock'
})

defineProps({
  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  }
})

const mediaStore = useMediaStore()
const { postByCategory, categoryConfig } = storeToRefs(mediaStore)
await mediaStore.getPostsByCategory({
  categories: categoryConfig.value
})

const getItems = computed(() => {
  return postByCategory.value['in_the_news']?.items?.slice(0, 3) ?? []
})

const swiper = ref(null)

onMounted(async () => {
  await nextTick()

  const el = swiper.value

  if (el) {
    const params = {
      injectStyles: [
        `
        .swiper-pagination {
          display: none;
      }
       host .swiper-pagination {
            height: 8px;
            display: none;
          }

          :host .swiper-pagination-bullet-active {
            background-color: ${semanticColorLookup(
          'primary.default'
        )} !important;
          }

          :host .swiper-pagination-bullet {
            background-color: ${semanticColorLookup('outline.default')}; 
            width: 16px;
            height: 16px;
            position: relative;
            top: 0px;
          }

          :host .swiper {
            width: calc(100%);
          }

          :host .swiper {
            max-width: 1280px;
            overflow: initial;
          }
      `
      ],
      pagination: {
        clickable: true
      },
      spaceBetween: 32,
      breakpoints: {
        980: {
          slidesPerGroup: 3
        }
      }
    }

    Object.assign(el, params)
    el.initialize()
  }
})
</script>
